import Checkbox from 'components/inputs/Checkbox';
import { OrderedSet, Set } from 'immutable';
import moment from 'moment';
import React from 'react';
import { RFIForwardActivity } from 'records/RFIForwardActivity';
import { truncateString } from 'utils/general';
import { useTranslator, useDateFormatter } from '@bluebeam/react-i18n';
import RFIOverlayAttachments from '../RFIOverlayAttachments';

type Props = {
  activity: RFIForwardActivity;
  isFirstActivity: boolean;
  selectedDiscussionIds: OrderedSet<string>;
  setSelectedDiscussionIds: (activityid: string) => void;
  canAttach: boolean;
  forwardingList: Set<string>;
  projectid: string;
};
const ForwardRFIDiscussionItem: React.FC<Props> = ({
  activity,
  isFirstActivity,
  canAttach,
  forwardingList,
  selectedDiscussionIds,
  setSelectedDiscussionIds,
  projectid,
}) => {
  const hasAttachments =
    activity.pageids?.size > 0 || activity.attachments?.size > 0;
  const { translate } = useTranslator(['formLabels']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'medium',
    timeStyle: 'short',
  });

  return (
    <div className="bgd-white b-3 my3 oh" key={activity.timestamp}>
      <div className="row justify-between p3 bb-3">
        <div className="row">
          {!isFirstActivity && canAttach ? (
            <>
              <div className="mr3">
                <Checkbox
                  id={`forward-rfi-message-${activity.timestamp}`}
                  onChange={() => setSelectedDiscussionIds(activity.id)}
                  checked={selectedDiscussionIds?.contains(activity.id)}
                />
              </div>
              <div className="normal">
                {`${translate('formLabels:from')} ${truncateString(
                  activity.email,
                  15
                )}`}
              </div>
            </>
          ) : (
            <div className="normal">
              {`${translate('formLabels:from')} ${truncateString(
                activity.email,
                19
              )}`}
            </div>
          )}
        </div>
        <div className="light color-gray-6 font-size-4 right">
          {dateFormatter?.format(new Date(activity.timestamp * 1000))}
        </div>
      </div>
      <div className="column p3 bgd-gray-2">
        {isFirstActivity && (
          <div className="mb3">
            <div className="black-2 font-size-5 medium mb1">
              {translate('formLabels:to')}
            </div>
            <div className="black-1 font-size-5 light">
              {forwardingList.join('; ')}
            </div>
          </div>
        )}
        <div className="mb3">
          <div className="black-2 font-size-5 medium mb1">
            {translate('formLabels:message')}
          </div>
          <div className="black-1 font-size-5 light">{activity.message}</div>
        </div>
        {hasAttachments && (
          <div>
            <RFIOverlayAttachments
              label={translate('formLabels:attachments')}
              projectId={projectid}
              attachments={activity.attachments}
              attachedSheetversions={activity.sheetVersions}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { ForwardRFIDiscussionItem };
